module.exports = __webpack_public_path__ + "static/rislaine-270a6cc86320682ec0e91f7f3e926a39.png";